module.exports = __webpack_public_path__ + "static/img/6.9f194d1.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/4/1/zh/6.png
// module id = AxzT
// module chunks = 0